import { UPDATE_RUNTIME } from "../actionTypes";

const initialState = {
  msgOpen: false,
  msgType: "info", // 消息类型
  msgContent: "", // 消息内容
  alertOpen: false,
  alertCancel: false,
  alertTitle: "系统提示",
  alertContent: "",
  alertAction: () => {},
  isFull: false, // 是否充满页面,
  showSignInDialog: false, // 显示登录弹出框
  pageTitle: "", // 菜单外页面的标题
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_RUNTIME: {
      const content = action.payload;
      return {
        ...state,
        ...content,
      };
    }
    default:
      return state;
  }
}
